<style lang="scss">
.services{
    margin-top: 30px;
    .widget-title{
        color: #ff5b94;
        font-family: Poppins;
        font-size: 30px;
        font-weight: 600;
        text-transform: uppercase;
    }

    .browseAll {
        width: 160px;
        height: 43px;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
        border-radius: 5px;
        background-color: #ff1466;
        color: #ffffff;
        font-family: Poppins;
        font-size: 14px;
        font-weight: 500;
        margin-top: 10px;
        padding: 14px 16px;
    }
}

@media (max-width: 900px) {
    .services {
        .service-container {
            padding-left: 4px;
            padding-right: 4px;
        }
    }
}

@media (max-width: 768px) {
    .services {
        .service-container {
            padding: 4px;
        }
    }
}

@media (max-width: 500px) {
    .services {
        .browseAll {
            width: 100%;
        }
    }
}

</style>
<template>
    <div class="services" v-if="services.length > 0">
        <h3 class="widget-title" :style="$highlightColor">Services</h3>
        <template v-if="services">
            <div class="row">
                <div class="col-xs-12 col-sm-4 col-md-4 service-container" v-for="(service, index) in services" :key="index" >
                    <service-container :service="service"></service-container>
                </div>
            </div>

            <router-link v-if="config.servicesPage && showBrowseAll" :to="{name: config.servicesPage.id}" class="btn browseAll" :style="$mainButtonStyle">Browse All</router-link>

        </template>
        <div v-else class="text-center">
            <loading-icon></loading-icon>
        </div>

    </div>

</template>

<script>
import ServiceContainer from '../services/list/service-container.vue'
import LoadingIcon from './../loadingicon.vue'
import ServiceRepository from '../../mixins/service-repository'
import Configure from './../../mixins/configure'

export default {
    props: ['pageId'],
    components: {
        ServiceContainer,LoadingIcon
    },
    data() {
        return {
            music: [],
            showBrowseAll: true
        }
    },
    computed: {
        page() {
            if (this.pageId) {
                return this.config.getPageById(this.pageId)
            }
            return false
        },
        config() {
            return this.$store.state.currentConfig
        },
        user() {
            return this.$store.state.user
        },
        services () {
            return this.$store.state.discoverPlaylist.services
        }
    },
    mixins: [Configure, ServiceRepository],

}
</script>
